module.exports = __webpack_public_path__ + "static/stanaka-c78f98d363a279800baa7a69bd107244.jpg";